import React, {useEffect, useState} from "react";
import associateServices from "../../../../services";
import Big from "big.js";
import Loading from "../../../../components/loading";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import './index.css'
import {decrypt, encrypt} from "../../../../helpers/encryption";
import {Tooltip} from "react-tooltip";
import RankIcon from "../../../../components/rank-icon";
import moment from "moment/moment";
import InstrumentIcon from "../../../../components/instrument-icon";
import NoData from "../../../../components/no-data";

const CorrectionModal = () => {
    const {t} = useTranslation()
    const {selectedWallet} = useSelector(state => state.authenticationReducer)
    const [reloads, setReloads] = useState({})
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState({})

    useEffect(() => {
        getCorrections(selectedWallet?.code)
    }, [selectedWallet?.code])

    const getCorrections = (code) => {
        if (!code) {
            console.log('NO CODE FOUND')
            return false;
        }

        associateServices.checkCorrection({
            code
        }).then(res => {
            if (res?.data?.length >= 1 || res?.data?.id)
                setData(res?.data)
            setLoading(false)
        })
    }
    return (
        <div>
            {
                loading ? <Loading/> :

                    !data?.id ?
                        <NoData desc={t(`transactions.corrections.empty`)}/>

                        :
                        <>
                            <div
                                className="form__group d-flex flex-column align-items-center justify-content-center flex-wrap gap-4">

                                <div className="progress-wrapper home-progress container">
                                    <div className="modal__profile">


                                        <div className="d-flex align-items-center gap-2">
                                            <div className="modal__icon">

                                                <Tooltip anchorSelect={`#current-rank`} className="tooltip-me">
                                                    <span className="gap-2">
                                                        {/*<RankIcon icon={data?.current?.icon}/>*/}
                                                        {data?.currency}
                                                    </span>
                                                </Tooltip>

                                                <span id="current-rank">
                                                <InstrumentIcon code={data?.currency}/>
                                            </span>
                                            </div>

                                            <div className="modal__user">
                                                <span>{moment.unix(data?.timestamp).format("MMM Do YY")}</span>
                                                <span>{Big(data?.amount || 0).toFixed(['TRY', 'USD', 'USDT']?.includes(data.currency) ? 2 : 8)} {data?.currency}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal__progress">
                                        <div className="modal__progress-text">
                                            <span className={"d-flex gap-1"}>
                                                <InstrumentIcon code={data?.currency}/>
                                                {Big(data?.wagered_currency || data?.wagered || 0).toFixed(['TRY', 'USD', 'USDT']?.includes(data.currency) ? 2 : 8)}
                                            </span>
                                            <span className={"d-flex gap-1"}>
                                                {Big(data?.required_wager_currency || data?.required_wager || 0).toFixed(['TRY', 'USD', 'USDT']?.includes(data.currency) ? 2 : 8)}
                                                <InstrumentIcon code={data?.currency}/>
                                            </span>
                                        </div>
                                        <div className="modal__progress-bar">
                                        <span
                                            style={{width: `${parseFloat(Big(data?.wagered_currency || data?.wagered || 0).div(data?.required_wager_currency || data?.required_wager || 0).times(100).toFixed(2))}%`}}/>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </>

            }

        </div>
    )

}


export default CorrectionModal
